import { Component } from 'react';
import * as React from 'react';
import { DaySpanComponent } from '../../controls/DaySpan';
import { TimeTableComponent } from '../../controls/TimeTable';
import { ITimeTableDay } from '../../models/ITimeTableDay';
import { IClinicListItem } from '../../models/IClinicListItem';
import { ClinicComboComponent } from '../../controls/ClinicCombo';
import * as moment from 'moment';
import { SchedulerService } from '../../services/SchedulerService';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { IVisitInfo } from '../../models/IVisitInfo';
import { SetVisitInfo } from '../../actions/VisitActions';
import { LoaderComponent } from '../../controls/Loader';
import './PhysiotherapistView.css'
import { ITimeTable } from '../../models/ITimeTable';


interface IProps {
    SaveVisitInfo: (data: IVisitInfo) => void,
    PhysiotherapistId: string,
    Clinics: IClinicListItem[],
    SelectedClinic?: IClinicListItem,
    OnClinicSelected: (clinic: IClinicListItem) => void,
    ShowClinicOnMap?: (clinic: IClinicListItem) => void
}

interface IState {
    TimeTable: ITimeTable,
    TimeTableDays: ITimeTableDay[],
    DaySpanFrom: Date,
    DaySpanTo: Date,
    Redirect: boolean,
    LoaderVisible: boolean,
    SectionOpen: boolean,
    DayNumbers: number
}

class ArrangeVisitComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        const DAY_SPAN = window.innerWidth < 768 ? 3 : 5;
        let daySpanFrom = new Date();
        daySpanFrom.setHours(0, 0, 0, 0);
        daySpanFrom.setDate(daySpanFrom.getDate() + 1);
        let daySpanTo = new Date();
        daySpanTo.setHours(0, 0, 0, 0);
        daySpanTo.setDate(daySpanTo.getDate() + DAY_SPAN);

        this.state = {
            TimeTable: {
                PhysiotherapistId: this.props.PhysiotherapistId,
                HasAnyWorkHours: false,
                TimeTableDay: []
            },
            TimeTableDays: [],
            DaySpanFrom: daySpanFrom,
            DaySpanTo: daySpanTo,
            Redirect: false,
            LoaderVisible: this.props.SelectedClinic !== undefined || this.props.Clinics.length > 0,
            SectionOpen: false,
            DayNumbers: DAY_SPAN
        }

        this.OnDaySpanChange = this.OnDaySpanChange.bind(this);
        this.OnTimeTableClick = this.OnTimeTableClick.bind(this);
        this.RefreshTimeTableDays = this.RefreshTimeTableDays.bind(this);
        this.OnGetTimeTableSuccess = this.OnGetTimeTableSuccess.bind(this);
        this.OnGetTimeTableError = this.OnGetTimeTableError.bind(this);
        this.OnClinicSelected = this.OnClinicSelected.bind(this);
        this.OnHeaderClick = this.OnHeaderClick.bind(this);
        this.ShowMap = this.ShowMap.bind(this);

        if (this.props.SelectedClinic) {
            this.RefreshTimeTableDays(
                this.props.PhysiotherapistId,
                this.props.SelectedClinic.Id,
                this.state.DaySpanFrom,
                this.state.DaySpanTo);
        } else {
            if (this.props.Clinics.length > 0) {
                this.RefreshTimeTableDays(
                    this.props.PhysiotherapistId,
                    this.props.Clinics[0].Id,
                    this.state.DaySpanFrom,
                    this.state.DaySpanTo);
            }
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (this.props.SelectedClinic === nextProps.SelectedClinic &&
            this.props.PhysiotherapistId === nextProps.PhysiotherapistId) {
            return;
        }

        if (this.props.SelectedClinic === undefined) {
            if (nextProps.SelectedClinic !== undefined) {
                this.RefreshTimeTableDays(
                    nextProps.PhysiotherapistId,
                    nextProps.SelectedClinic.Id,
                    this.state.DaySpanFrom,
                    this.state.DaySpanTo);
            }
        } else {
            if (nextProps.SelectedClinic === undefined) {
                if (nextProps.Clinics.length > 0) {
                    this.RefreshTimeTableDays(
                        nextProps.PhysiotherapistId,
                        nextProps.Clinics[0].Id,
                        this.state.DaySpanFrom,
                        this.state.DaySpanTo);
                }
            } else {
                if (this.props.SelectedClinic.Id !== nextProps.SelectedClinic.Id) {
                    this.RefreshTimeTableDays(
                        nextProps.PhysiotherapistId,
                        nextProps.SelectedClinic.Id,
                        this.state.DaySpanFrom,
                        this.state.DaySpanTo);
                }
            }
        }
    }

    public componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    public render() {
        return (
            <div className="arrange-visit-component section">
                {this.RenderRedirect()}
                <div onClick={this.OnHeaderClick}
                    className={this.state.SectionOpen ? "header" : "header header-closed"} >
                    Umów wizytę<span>&nbsp;</span>
                </div>
                <div className="arrange-visit-component-inner">
                    <div className="address-header">
                        <div className="left">
                            Adres
                        </div>
                        <div className="right">
                            {
                                this.props.SelectedClinic ?
                                    (this.props.SelectedClinic.IsTele ? null : (<a onClick={this.ShowMap}>Widok mapy</a>)) :
                                    null
                            }
                        </div>
                    </div>
                    <div className="address-combo-container">
                        <ClinicComboComponent
                            Clinics={this.props.Clinics}
                            SelectedClinic={this.props.SelectedClinic ?
                                this.props.SelectedClinic :
                                (this.props.Clinics.length > 0 ? this.props.Clinics[0] : undefined)
                            }
                            OnClinicSelected={this.OnClinicSelected} />
                    </div>
                    {
                        this.props.SelectedClinic && this.props.SelectedClinic.IsHomeService ?
                            <div className="phone-info">
                                <span className="phone-info__text">
                                    Aby umówić wizytę domową należy skontaktować się telefonicznie podając preferowaną datę i terminy.
                                                </span>
                                <div className="phone-info__phone">
                                    <div className="phone-icon" />
                                    <div>{this.props.SelectedClinic.Phone}</div>
                                </div>
                            </div>
                            :
                            <>
                                <div className="calendar-header">
                                    <div className="left">
                                        Terminy
                                </div>
                                </div>
                                <div className="day-span">
                                    <DaySpanComponent
                                        DaySpan={this.state.DayNumbers}
                                        OnSpanChange={this.OnDaySpanChange}
                                        StartDate={this.state.DaySpanFrom} />
                                </div>
                                <div className="time-table">
                                    <LoaderComponent Visible={this.state.LoaderVisible} />
                                    <TimeTableComponent
                                        TimeTable={this.state.TimeTable}
                                        OnHourClick={this.OnTimeTableClick}
                                        MaxDayLength={5}
                                        PhysiotherapistId={this.props.PhysiotherapistId} />
                                </div>
                            </>
                    }

                </div>
            </div>
        );
    }//end-of-render

    private RenderRedirect() {
        if (this.state.Redirect) {
            return (
                <Redirect to={'/arrangevisit/firststep'} push={true} />
            );
        } else {
            return null;
        }
    }

    private OnDaySpanChange(dayFrom: Date, dayTo: Date) {
        this.setState({
            DaySpanFrom: dayFrom,
            DaySpanTo: dayTo
        });
        this.RefreshTimeTableDays(
            this.props.PhysiotherapistId,
            this.props.SelectedClinic ? this.props.SelectedClinic.Id :
                (this.props.Clinics.length > 0 ? this.props.Clinics[0].Id : (-1)),
            dayFrom,
            dayTo);
    }

    private OnTimeTableClick(date: Date, physiotherapistId: string, clinicId: number | undefined) {
        if (this.props.SelectedClinic !== undefined || this.props.Clinics.length > 0) {
            this.props.SaveVisitInfo({
                PhysiotherapistId: this.props.PhysiotherapistId,
                ClinicId: (this.props.SelectedClinic ? this.props.SelectedClinic.Id : this.props.Clinics[0].Id),
                StartTime: date
            });
            this.setState({
                Redirect: true
            });
        }
    }

    private RefreshTimeTableDays(
        physiotherapistId: string,
        clinicId: number,
        dateFrom,
        dateTo,
    ) {
        if (clinicId === -1) {
            return;
        }
        if (this.state.LoaderVisible === false) {
            this.setState({
                LoaderVisible: true
            });
        }

        let service = new SchedulerService();
        service.GetTimeTable(
            physiotherapistId,
            clinicId,
            dateFrom,
            dateTo,
            this.OnGetTimeTableSuccess,
            this.OnGetTimeTableError);
    }

    private OnGetTimeTableSuccess(result) {
        result.data.Value.TimeTableDay.forEach((day) => {
            day.Day = new Date(day.Day);
            day.Hours.forEach((hour) => {
                hour.StartHour = moment(hour.StartHour, 'HH:mm:ss').format('HH:mm');
                hour.EndHour = moment(hour.EndHour, 'HH:mm:ss').format('HH:mm');
            });
        });
        this.setState({
            TimeTable: result.data.Value,
            LoaderVisible: false
        });
    }

    private OnGetTimeTableError(error) {
        console.error(error);
    }

    private OnClinicSelected(clinic: IClinicListItem) {
        this.props.OnClinicSelected(clinic);
    }

    private OnHeaderClick() {
        this.setState({
            SectionOpen: !this.state.SectionOpen
        });
    }

    private ShowMap(evt) {
        if (this.props.ShowClinicOnMap !== undefined &&
            (this.props.SelectedClinic !== undefined || this.props.Clinics.length > 0)
        ) {
            this.props.ShowClinicOnMap(this.props.SelectedClinic ? this.props.SelectedClinic : this.props.Clinics[0]);
        }
    }

    private handleResize = () => {
        this.setState({
            DayNumbers: window.innerWidth < 768 ? 3 : 5
        });
    };
}

export default connect(undefined, {
    SaveVisitInfo: SetVisitInfo
})(ArrangeVisitComponent);


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/ArrangeVisit.tsx